import { LandingLayout } from "features/layouts/landing-layout/components";
import { useLocation } from "react-router-dom";
import NOT_FOUND from "assets/404.gif";
import UNAUTHORIZED from "assets/401.png";
import styles from "./error-boundary.module.scss";
export const ErrorBoundary = () => {
  const location = useLocation();
  if (location.pathname === "/error-unauthorize") {
    return (
      <LandingLayout>
        <section className="w-100 flex-center bg-light py-5">
          <div className="col-6  flex-center flex-column">
            <h3 className="h3 text-primary m-3">
              زمان استفاده شما از پنل تمام شده است لطفا دوباره وارد شوید
            </h3>
            <img src={UNAUTHORIZED} alt="not-found-gif" className="w-75 m-2" />
          </div>
        </section>
      </LandingLayout>
    );
  } else {
    return (
      <LandingLayout>
        <section className={styles.error_boundary_container}>
          <div className="col-md-6 col-12  flex-center flex-column">
            <h3 className="h3 text-primary m-3">
              متاسفانه صفحه ی موررد نظر پیدا نشد!
            </h3>
            <img src={NOT_FOUND} alt="not-found-gif" className="w-100 m-2" />
          </div>
        </section>
      </LandingLayout>
    );
  }
};
